// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VIXfRV {
  cursor: pointer;
  transition: color 0.2s ease;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  display: inline-block;
  align-items: center;
  justify-content: center;
  font: inherit;
  color: inherit;
}

.oAAU_L {
  position: absolute;
  min-width: 200px;
  background-color: var(--surface-neutral-white);
  color: var(--text-neutral-white);
  border-radius: var(--radius-s);
  padding: var(--spacing-1-5) 0 var(--spacing-1-5) var(--spacing-2);
  font-family: var(--font-family-base);
  box-shadow: var(--shadow-sm);
  word-wrap: break-word;
  box-sizing: border-box;
  animation: AReUhZ 0.2s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .oAAU_L {
    animation: none;
  }
}

@media (prefers-contrast: high) {
  .oAAU_L {
    border: 1px solid var(--text-neutral-white);
  }
}

.oAAU_L[style*='opacity: 0.01'] {
  animation: none;
  transition: none;
  pointer-events: none;
}

.oAAU_L:not([style*='opacity: 0.01']) {
  pointer-events: auto;
}

.vegIv3 {
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
  z-index: 1;
  max-height: 130px;
  overflow: auto;
  padding-right: var(--spacing-0-5);
}

.H3k48n {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.Q4P6DN {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--spacing-1);
  padding: 0;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  line-height: var(--line-height-160);
  flex-shrink: 0;
  white-space: nowrap;
}

.ZLJSyc::after {
  content: '';
  position: absolute;
  top: 50%;
  left: -8px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 8px 8px 0;
  border-color: transparent rgba(0, 0, 0, 0.1) transparent transparent;
  z-index: -1;
  pointer-events: none;
  filter: blur(1px);
}

.Ny8MxO::after {
  content: '';
  position: absolute;
  top: 50%;
  right: -8px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 0 8px 8px;
  border-color: transparent transparent transparent rgba(0, 0, 0, 0.1);
  z-index: -1;
  pointer-events: none;
  filter: blur(1px);
}

.k9XGEx {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  z-index: 1;
}

.UzQYw3 {
  left: -8px;
  border-width: 9px 9px 9px 0;
  border-color: transparent var(--surface-neutral-white) transparent transparent;
}

.CQMXcx {
  right: -8px;
  border-width: 9px 0 9px 9px;
  border-color: transparent transparent transparent var(--surface-neutral-white);
}

@keyframes AReUhZ {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BeneficiaryDetailsTooltip/BeneficiaryDetailsTooltip.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,gCAAgC;EAChC,8BAA8B;EAC9B,iEAAiE;EACjE,oCAAoC;EACpC,4BAA4B;EAC5B,qBAAqB;EACrB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;EACV,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,mCAAmC;EACnC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,oEAAoE;EACpE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,oEAAoE;EACpE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,8EAA8E;AAChF;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,8EAA8E;AAChF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".iconTrigger {\n  cursor: pointer;\n  transition: color 0.2s ease;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  display: inline-block;\n  align-items: center;\n  justify-content: center;\n  font: inherit;\n  color: inherit;\n}\n\n.tooltip {\n  position: absolute;\n  min-width: 200px;\n  background-color: var(--surface-neutral-white);\n  color: var(--text-neutral-white);\n  border-radius: var(--radius-s);\n  padding: var(--spacing-1-5) 0 var(--spacing-1-5) var(--spacing-2);\n  font-family: var(--font-family-base);\n  box-shadow: var(--shadow-sm);\n  word-wrap: break-word;\n  box-sizing: border-box;\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .tooltip {\n    animation: none;\n  }\n}\n\n@media (prefers-contrast: high) {\n  .tooltip {\n    border: 1px solid var(--text-neutral-white);\n  }\n}\n\n.tooltip[style*='opacity: 0.01'] {\n  animation: none;\n  transition: none;\n  pointer-events: none;\n}\n\n.tooltip:not([style*='opacity: 0.01']) {\n  pointer-events: auto;\n}\n\n.tooltipContent {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  position: relative;\n  z-index: 1;\n  max-height: 130px;\n  overflow: auto;\n  padding-right: var(--spacing-0-5);\n}\n\n.tooltipSection {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.tooltipRow {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: var(--spacing-1);\n  padding: 0;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-160);\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.tooltipRight::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: -8px;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 8px 8px 8px 0;\n  border-color: transparent rgba(0, 0, 0, 0.1) transparent transparent;\n  z-index: -1;\n  pointer-events: none;\n  filter: blur(1px);\n}\n\n.tooltipLeft::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: -8px;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 8px 0 8px 8px;\n  border-color: transparent transparent transparent rgba(0, 0, 0, 0.1);\n  z-index: -1;\n  pointer-events: none;\n  filter: blur(1px);\n}\n\n.arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-style: solid;\n  z-index: 1;\n}\n\n.arrowRight {\n  left: -8px;\n  border-width: 9px 9px 9px 0;\n  border-color: transparent var(--surface-neutral-white) transparent transparent;\n}\n\n.arrowLeft {\n  right: -8px;\n  border-width: 9px 0 9px 9px;\n  border-color: transparent transparent transparent var(--surface-neutral-white);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconTrigger": `VIXfRV`,
	"tooltip": `oAAU_L`,
	"fadeIn": `AReUhZ`,
	"tooltipContent": `vegIv3`,
	"tooltipSection": `H3k48n`,
	"tooltipRow": `Q4P6DN`,
	"tooltipRight": `ZLJSyc`,
	"tooltipLeft": `Ny8MxO`,
	"arrow": `k9XGEx`,
	"arrowRight": `UzQYw3`,
	"arrowLeft": `CQMXcx`
};
module.exports = ___CSS_LOADER_EXPORT___;
